import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { Risk } from '../../types';
import { primaryRiskColorStyles } from '../../styles';
import VeraLabel from './vera-label';

export interface Props {
  className?: string;
  score: number;
  risk: Risk;
}

class VeraScoreLabel extends React.Component<Props, any> {
  public static defaultProps: Props = {
    risk: 'at-risk',
    score: 0,
  };

  public render() {
    const { className, risk, score } = this.props;
    return (
      <VeraLabel className={`${className} risk-${risk}`}>{score}</VeraLabel>
    );
  }
}

export default styled(VeraScoreLabel)`
  ${primaryRiskColorStyles('background-color', '&')};
`;
